import React from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";

const ClassAttendanceResultsTable = ({ loading, studentResults, selectedWeek }) => {
  const navigate = useNavigate();

  // 정렬 상태 구현 (실제로는 useState 사용)
  const sortedResults = [...studentResults];
  
  // 세부 결과 조회 버튼 클릭 핸들러
  const handleViewDetails = (studentId) => {
    console.log(selectedWeek);
    // 쿼리스트링으로 전달
    navigate(
      `/page/studentWeeklyResults?studentId=${studentId}&startDate=${selectedWeek.startDate}&endDate=${selectedWeek.endDate}`
    );
  };
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-[20px] shadow overflow-hidden w-[1044px] mb-40">
      {/* 테이블 - 전체 테두리 추가 */}
      <div className="mx-[27px] my-[32px]">
        <div className="rounded-t-[20px] overflow-hidden">
          <table className="w-full border-collapse table-fixed">
            {/* 헤더 - 테두리 없음 */}
            <thead className="bg-[#F3F7FF] text-[16px] font-[700] text-[#9BA5C2] h-[56px] border border-[#F3F7FF]">
              <tr>
                <th className="w-[70px] text-center">번호</th>
                <th className="w-[80px] text-center">이름</th>
                <th className="w-[108px] text-center">학습 시간</th>
                <th className="w-[100px] text-center">정확도</th>
                <th className="w-[132px] text-center">총 학습량</th>
                <th className="w-[56px] text-center">월</th>
                <th className="w-[56px] text-center">화</th>
                <th className="w-[56px] text-center">수</th>
                <th className="w-[56px] text-center">목</th>
                <th className="w-[56px] text-center">금</th>
                <th className="w-[56px] text-center">토</th>
                <th className="w-[56px] text-center">일</th>
                <th className="w-[108px] text-center">결과보기</th>
              </tr>
            </thead>
            
            {/* 바디 - 각 행에 상단 테두리 없음, 행 사이에만 구분선 */}
            <tbody>
              {sortedResults.map((student, index, array) => (
                <tr 
                  key={student.id} 
                  className={`hover:bg-gray-50 text-[14px] text-[#5E6169] h-[56px] border-l border-r border-b border-[#E9E9E9] ${
                    index > 0 ? 'border-t border-[#E9E9E9]' : ''
                  }`}
                >
                  <td className="text-center border-r border-[#E9E9E9] text-[20px]">{student.number}</td>
                  <td className="text-center border-r border-[#E9E9E9] truncate px-2 max-w-[80px] overflow-hidden text-ellipsis whitespace-nowrap" title={student.name}>{student.name}</td>
                  <td className="text-center border-r border-[#E9E9E9] truncate px-2 overflow-hidden text-ellipsis whitespace-nowrap" title={student.totalStudyTime}>{student.totalStudyTime}</td>
                  <td className="text-center border-r border-[#E9E9E9] truncate px-2 overflow-hidden text-ellipsis whitespace-nowrap" title={student.averageAccuracy}>{student.averageAccuracy}</td>
                  <td className="text-center border-r border-[#E9E9E9] truncate px-2 overflow-hidden text-ellipsis whitespace-nowrap" title={`${student.weeklyStageCnt}개`}>{student.weeklyStageCnt}개</td>
                  
                  {/* 요일별 점수 - 그룹화하여 하나의 외곽선만 표시 */}
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.mon === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.mon}
                    </div>
                  </td>
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.tue === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.tue}
                    </div>
                  </td>
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.wed === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.wed}
                    </div>
                  </td>
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.thu === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.thu}
                    </div>
                  </td>
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.fri === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.fri}
                    </div>
                  </td>
                  <td className="text-center" style={{ borderRight: 'none' }}>
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.sat === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.sat}
                    </div>
                  </td>
                  <td className="text-center border-r border-[#E9E9E9]">
                    <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center ${student.sun === '-' ? 'bg-none' : 'bg-blue-100 text-[#44474E] text-[16px] font-[700]'}`}>
                      {student.sun}
                    </div>
                  </td>
                  
                  <td className="text-center">
                    <button
                      onClick={() => handleViewDetails(student.id)}
                      className="w-[82px] py-1 text-[14px] text-[#355BDF] font-[700] border-[2px] border-[#355BDF] rounded-full hover:bg-blue-100"
                    >
                      바로가기
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 데이터 없음 */}
      {sortedResults.length === 0 && (
        <div className="flex justify-center items-center p-8 text-gray-500">
          결과가 없습니다
        </div>
      )}
    </div>
  );
};

export default ClassAttendanceResultsTable;